import { render } from "./Gear.vue?vue&type=template&id=110913c6"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Gear.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "110913c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('110913c6', __exports__)) {
    api.reload('110913c6', __exports__)
  }
  
  module.hot.accept("./Gear.vue?vue&type=template&id=110913c6", () => {
    api.rerender('110913c6', render)
  })

}


export default __exports__